/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SpaceEligibilityRpc
 */

export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const CustomerSuccessPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.CustomerSuccessPortalError';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorTypename = 'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';

/**
 *  One creatable space type surfaced to a portal consumer. {@code setupBasePath} is the
 *  type-relative path (e.g. {@code /billing/:portalInstanceId?}) the consumer resolves against its
 *  own host — the service intentionally does not build absolute URLs. {@code locked} means the
 *  type's gate is met but the acting user lacks a required scope; consumers may show it disabled or
 *  hard-hide it.
 */

export const TranslationsErrorTypename = 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const listCreatableSpacesRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.SpaceEligibilityRpc',
  rpcName: 'listCreatableSpaces',
  auth: 'external',
  fingerprint: 'gTQv-1pyB3LV_rCy3U2xK3OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};